import {Injectable} from "@angular/core";
import {BaseService} from "@core/service/base.service";
import {HttpClient} from '@angular/common/http';
import {catchError, tap} from "rxjs/operators";
import {Observable} from "rxjs/index";


@Injectable({providedIn: 'root'})
export class JyRoleService extends BaseService {

  private url = 'api/role';  // URL to web api

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(): string {
    return this.url;
  }


  all():Observable<any>{
    const url = `${this.getUrl()}/all`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`all role`)),
      catchError(this.handleError<any>(`get all role`))
    );
  }



}

